module.exports = __webpack_public_path__ + "img/nodata-oil.08635fe2.png";